import axios from 'axios';
import { errorHandler } from '../services/ErrorHandler';

const httpClient = axios.create({
  withCredentials: true,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-type': 'application/json',
  },
});

export const onFulfilled = res => res.data.result;

export const onRejected = error => {
  errorHandler.handle(error?.response?.data);
  throw error;
};

httpClient.interceptors.response.use(onFulfilled, onRejected);

export {
  httpClient,
};
